import {t} from "@lingui/core/macro";

import {getPromptVariables} from "@khan/guide-core-helpers";

/**
 * Get classroom page metadata including title and type.
 */
export const getClassroomPageMetadata = (isClassroomPage: boolean) => {
    if (!isClassroomPage) {
        return {};
    }

    const promptVariables = getPromptVariables();

    const pageType = promptVariables.contentKind ?? "*";
    const pageTitle = promptVariables.contentTitle ?? t`Tutor me`;

    return {
        pageType,
        pageTitle,
    };
};
